import TemplateView from '../TemplateView'
import {TaskManagementViewMode} from './constants'
import KanbanFiltersPanel from './kanban/components/KanbanFiltersPanel'
import TaskListFilterPanel from './tasksTable/TaskListFilterPanel'

export default class FiltersPanelContainer extends TemplateView {
    constructor({
        onAllSelectedChanged = allSelected => {},
        onMinimizedCardsChanged = minimizedCards => {},
        onCollapseAllChanged = isAllCollapsed => {},
    }) {
        super()

        this.state = {
            viewMode: null,

            taskStatusFilter: {
                allSelected: true,
                statusTypes: [],
                statusIds: []
            },
            workflowStatusesMap: {},
            minimizedCards: false,
            showSelection: false,
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {},
            },
            singleCPSelection: {},
            ignoreProjectCollapse: false,
        }

        this.callbacks = {
            onAllSelectedChanged,
            onMinimizedCardsChanged,
            onCollapseAllChanged,
        }

        this.onStatePropertyChanged('viewMode', this._handleViewModeChanges)

        this.onAnyStatePropertyChanged(
            [
                'allTasksSelected',
                'taskStatusFilter',
                'workflowStatusesMap',
                'minimizedCards',
                'showSelection',
                'collapsedProjects',
                'singleCPSelection',
                'ignoreProjectCollapse',
            ],
            state => this.kanbanFiltersPanel.setState(state)
        )
    }

    _handleViewModeChanges = (viewMode) => {
        this.$kanbanFilters.toggle(viewMode === TaskManagementViewMode.KANBAN)
        this.$taskTableFilters.toggle(viewMode === TaskManagementViewMode.TABLE)
    }

    templateHtml() {
        return "<div class='filtersContainer'>" +
               "    <div class='kanbanFilters'/>" +
               "    <div class='taskTableFilters'/>" +
               "</div>"
    }

    afterRender() {
        this.$taskTableFilters = this.find(".taskTableFilters")
        new TaskListFilterPanel().init(this.$taskTableFilters)

        this.$kanbanFilters = this.find(".kanbanFilters")
        this.kanbanFiltersPanel = new KanbanFiltersPanel({
            onAllSelectedChanged: this.callbacks.onAllSelectedChanged,
            onMinimizedCardsChanged: this.callbacks.onMinimizedCardsChanged,
            onCollapseAllChanged: this.callbacks.onCollapseAllChanged,
        }).init(this.$kanbanFilters);
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/FiltersPanelContainer.js